export default function lsCycleFilter(value) {
    const frequencies = {
        0: 'One Time',
        7: 'Weekly',
        14: 'Bi-Weekly',
        28: 'Monthly',
    };

    return frequencies[value];
}
